import { render, staticRenderFns } from "./BudgetModule.vue?vue&type=template&id=68c0523e"
import script from "./BudgetModule.vue?vue&type=script&lang=js"
export * from "./BudgetModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports